<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="企业/单号/描述" style="width:220px" @keyup.enter.native="load" />
      <el-select v-model="status" clearable placeholder="状态" style="width:140px" @change="load">
        <el-option label="待办" value="PENDING" />
        <el-option label="待处理" value="OPEN" />
        <el-option label="处理中" value="PROCESSING" />
        <el-option label="已关闭" value="CLOSED" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="ticketNo" label="工单号" width="180" show-overflow-tooltip />
      <el-table-column prop="tenantName" label="企业" min-width="140" show-overflow-tooltip />
      <el-table-column prop="issueType" label="问题类型" width="110" />
      <el-table-column prop="content" label="问题描述" min-width="200" show-overflow-tooltip />
      <el-table-column prop="contactPhone" label="联系电话" width="120" />
      <el-table-column prop="createdByName" label="提交人" width="100" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="170" />
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="open(row)">{{ row.status === 'CLOSED' ? '查看' : '回复' }}</el-button>
          <el-button v-if="row.status !== 'CLOSED'" type="text" @click="closeTicket(row)">关闭</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="current && current.status === 'CLOSED' ? '工单详情' : '咨询工单处理'" :visible.sync="visible" width="760px" append-to-body @closed="onClosed">
      <div v-loading="detailLoading">
        <template v-if="current">
          <div class="ticket-meta">
            <span>{{ current.ticketNo }}</span>
            <span>{{ current.tenantName || '-' }}</span>
            <span>{{ current.issueType }}</span>
            <span>{{ statusText(current.status) }}</span>
            <span v-if="current.contactPhone">电话 {{ current.contactPhone }}</span>
          </div>

          <div class="message-list">
            <div
              v-for="(msg, idx) in (current.messages || [])"
              :key="msg.id || idx"
              class="message-item"
              :class="msg.senderType === 'OPS' ? 'ops' : 'tenant'"
            >
              <div class="message-head">
                <span class="sender">{{ msg.senderType === 'OPS' ? (msg.createdByName || '平台') : (msg.createdByName || '用户') }}</span>
                <span class="time">{{ msg.createdAt || '-' }}</span>
              </div>
              <div class="content-box" :class="{ reply: msg.senderType === 'OPS' }">{{ msg.content }}</div>
              <div v-if="(msg.attachments || []).length" class="file-list">
                <a
                  v-for="(a, i) in msg.attachments"
                  :key="a.id || i"
                  class="file-link"
                  :href="a.url"
                  target="_blank"
                  rel="noopener"
                >{{ a.fileName || ('附件' + (i + 1)) }}</a>
              </div>
            </div>
          </div>

          <template v-if="current.status !== 'CLOSED'">
            <el-divider content-position="left">平台回复</el-divider>
            <el-form label-width="96px" class="detail-form">
              <el-form-item label="回复内容" required>
                <el-input v-model="form.handleRemark" type="textarea" :rows="4" maxlength="2000" show-word-limit placeholder="填写回复内容" />
              </el-form-item>
              <el-form-item label="回复附件">
                <el-upload
                  action="#"
                  :http-request="elUploadHttpRequest"
                  :file-list="fileList"
                  :limit="9"
                  multiple
                  :on-success="onUploadSuccess"
                  :on-error="onUploadError"
                  :on-remove="onUploadRemove"
                  :on-preview="onUploadPreview"
                  :before-upload="beforeUpload"
                >
                  <el-button size="small" type="primary" plain>上传附件</el-button>
                  <div slot="tip" class="hint">最多 9 个</div>
                </el-upload>
              </el-form-item>
            </el-form>
          </template>
          <div v-else class="muted pad">工单已关闭。</div>
        </template>
      </div>
      <div slot="footer">
        <el-button @click="visible=false">关闭</el-button>
        <el-button
          v-if="current && current.status !== 'CLOSED'"
          type="warning"
          plain
          :loading="closing"
          @click="closeCurrent"
        >关闭工单</el-button>
        <el-button
          v-if="current && current.status !== 'CLOSED'"
          type="primary"
          :loading="saving"
          :disabled="detailLoading || !current"
          @click="save"
        >发送回复</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="previewVisible" append-to-body width="auto">
      <img v-if="previewUrl" :src="previewUrl" class="preview-img" alt="预览" />
    </el-dialog>
  </div>
</template>

<script>
import { listOpsConsultTickets, getOpsConsultTicket, replyOpsConsultTicket, closeOpsConsultTicket } from '../../api/consult'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'OpsConsultTicket',
  data() {
    return {
      list: [],
      loading: false,
      keyword: '',
      status: 'PENDING',
      visible: false,
      detailLoading: false,
      saving: false,
      closing: false,
      current: null,
      form: { handleRemark: '' },
      fileList: [],
      previewVisible: false,
      previewUrl: ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    statusText(s) {
      return ({ OPEN: '待处理', PROCESSING: '处理中', DONE: '处理中', CLOSED: '已关闭' }[s]) || s || '-'
    },
    async load() {
      this.loading = true
      try {
        const res = await listOpsConsultTickets({
          keyword: this.keyword || undefined,
          status: this.status || undefined
        })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    async open(row) {
      this.visible = true
      this.detailLoading = true
      this.current = null
      this.fileList = []
      this.form = { handleRemark: '' }
      try {
        const res = await getOpsConsultTicket(row.id)
        this.current = res.data || {}
      } catch (e) {
        this.visible = false
      } finally {
        this.detailLoading = false
      }
    },
    onClosed() {
      this.current = null
      this.fileList = []
      this.form = { handleRemark: '' }
    },
    beforeUpload(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error('单个附件请小于 20MB')
        return false
      }
      return true
    },
    onUploadSuccess(res, file, fileList) {
      const data = (res && res.data) || {}
      if (!data.id) {
        this.$message.error((res && res.message) || '上传失败')
        this.fileList = fileList.filter(f => f.uid !== file.uid)
        return
      }
      file.url = data.url
      file.response = { data }
      this.fileList = fileList
    },
    onUploadError() {
      this.$message.error('附件上传失败')
    },
    onUploadRemove(file, fileList) {
      this.fileList = fileList
    },
    onUploadPreview(file) {
      const url = file.url || (file.response && file.response.data && file.response.data.url)
      if (!url) return
      if (/\.(png|jpe?g|gif|webp|bmp)$/i.test(url) || (file.raw && /^image\//.test(file.raw.type))) {
        this.previewUrl = url
        this.previewVisible = true
      } else {
        window.open(url, '_blank')
      }
    },
    collectIds() {
      return (this.fileList || []).map(f => {
        const d = (f.response && f.response.data) || f.response || {}
        return d.id
      }).filter(Boolean)
    },
    async save() {
      if (!this.form.handleRemark || !this.form.handleRemark.trim()) {
        return this.$message.warning('请填写回复内容')
      }
      if ((this.fileList || []).some(f => f.status === 'uploading')) {
        return this.$message.warning('附件上传中，请稍候')
      }
      if ((this.fileList || []).some(f => f.status === 'fail')) {
        return this.$message.warning('存在上传失败的附件，请移除后重试')
      }
      this.saving = true
      try {
        const res = await replyOpsConsultTicket(this.current.id, {
          handleRemark: this.form.handleRemark.trim(),
          attachmentIds: this.collectIds()
        })
        this.current = res.data || {}
        this.form = { handleRemark: '' }
        this.fileList = []
        this.$message.success('已发送')
        this.load()
      } finally {
        this.saving = false
      }
    },
    async closeTicket(row) {
      try {
        await this.$confirm('确定关闭该工单？关闭后将无法继续回复。', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const fromDetail = this.current && this.current.id === row.id
      if (fromDetail) this.closing = true
      try {
        const res = await closeOpsConsultTicket(row.id)
        this.$message.success('工单已关闭')
        if (fromDetail) {
          this.current = res.data || { ...this.current, status: 'CLOSED' }
          this.form = { handleRemark: '' }
          this.fileList = []
        }
        this.load()
      } finally {
        if (fromDetail) this.closing = false
      }
    },
    async closeCurrent() {
      if (!this.current) return
      await this.closeTicket(this.current)
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
.ticket-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  color: #64748b;
  font-size: 13px;
}
.message-list { display: flex; flex-direction: column; gap: 14px; max-height: 360px; overflow-y: auto; padding-right: 4px; margin-bottom: 8px; }
.message-item.tenant .sender { color: #0f766e; }
.message-item.ops .sender { color: #2563eb; }
.message-head { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 6px; font-size: 13px; }
.message-head .time { color: #94a3b8; }
.detail-form >>> .el-form-item { margin-bottom: 10px; }
.content-box {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
}
.content-box.reply { background: #eff6ff; border-color: #bfdbfe; }
.file-list { display: flex; flex-direction: column; gap: 6px; margin-top: 6px; }
.file-link { color: #2563eb; font-size: 13px; }
.muted { color: #94a3b8; font-size: 13px; }
.pad { padding: 8px 0 16px; }
.hint { margin-top: 6px; color: #94a3b8; font-size: 12px; }
.preview-img { max-width: 80vw; max-height: 80vh; display: block; }
</style>
